const translation = {
    confirm: '你确定吗？',
    common: { back: '后退' },
    save: '保存',
    returnToGame: '您确定要返回游戏吗？',
    yes: '是的',
    no: '不',
    login: {
        auth: '授权',
        noAcc: '没有账号',
        reg: '登记',
        mail: '通过电子邮件登录',
        registration: '登记',
        agreement: '点击“注册”按钮，即表示您确认同意处理您的',
        agreementLink: '个人数据。',
        submit: '登记',
        continue: '继续',
        emailLabel: '电子邮件',
        passwordLabel: '密码',
        repeatPasswordLabel: '重复输入密码',
        loginButton: '登录',
        logout: '登出',
        invalidEmail: '电子邮件格式无效',
        invalidFormatPassword: '密码格式不正确',
        forgotPassword: '忘记密码了吗',
        passwordRecovery: '找回密码',
        passwordRecoveryTitle: '我们将发送一封信至指定邮箱',
        sendLetter: '寄信',
        userExists: '使用此电子邮件的用户已存在',
        userNotExists: '使用此电子邮件的用户不存在',
        passwordResetToMail: '重置密码的说明已通过电子邮件发送。',
        passwordValidation: '必须包含 8 到 20 个拉丁字母或数字',
        invalidPassword: '密码错误',
        sessionNotFound: '未找到会话',
        mismatchPassword: '密码不匹配！再试一次',
        rememberPassword: '记住您的密码',
        restore: '恢复',
        accExist: '有一个账户',
        confirmationCode: '输入通过电子邮件发送的确认码',
        code: '验证码',
        send: '发送',
        confirmation: '确认',
        resend: '重发',
        codeIsValid: '代码有效',
        codeNotValid: '代码无效',
        newPassword: '输入新的密码',
        passwordUsedBefore: '密码已被使用过',
        passwordUpdatedSuccessfully: '密码更新成功',
        enterEmail: '输入你的电子邮箱地址',
        enterPassword: '输入密码',
        enterPasswordAgain: '再次输入您的密码',
        enterAgreement: '确认您同意处理个人数据',
        notRobot: '证明你不是机器人。',
        deletionPersonalData: '要删除个人数据，请通过电子邮件向我们发送消息。',
    },
    profile: {
        edit: '编辑个人资料',
        remove: '删除帐户',
        projectName: '项目名',
        editing: '编辑您的个人资料',
        name: '你的名字',
        lastName: '你的姓氏',
        inputPattern: '从两个到十个字母',
        purchases: '购买缺失',
        settings: '设置',
        transactions: '交易',
        support: '支持',
    },
    payment: {
        toPay: '支付',
        method: '付款方式',
        pay: '支付',
        purchases: '购买',
        paymentMethod: '付款方式',
        debitCard: '借记卡',
        copy: '付款 ID 已复制！',
        cancellation: '您确定要取消付款吗？',
        email: '用于收取收据的电子邮件',
        status: {
            none: '无',
            pending: '挂起',
            paid: '已支付',
            fail: '失败',
        },
        state: {
            progress: '支付处理中',
            wait: '请稍候',
            paid: '已支付',
            successful: '支付成功',
            notPaid: '未支付',
            error: '错误',
            cancelled: '支付取消',
            cancel: '取消',
        },
    },
    games: {
        header: {
            buttonGuest: '访客',
            buttonLogin: '登录',
            buttonLogout: '注销',
        },
        buttonPlay: '玩',
        buttonInDevelop: '开发中',
    },
    support: {
        noPurchases: "您还没有购买记录",
        contactSupport: "联系客服",
        paymentId: "支付ID",
        userId: "用户ID",
        requestReason: "申请原因",
        feedbackEmail: "反馈邮箱",
        dropNotCredited: "未收到掉落奖励",
        other: "其他",
        success: '请求已接受',
        successText: '我们已收到您的请求，并将尽快通过电子邮件与您联系。',
        createTicket: '创建咨询',
        ticketTitle: '我的工单',
        requestDescription: '请尽可能详细地描述您的问题',
        requestTitleDescription: '请输入标题',
        ticketTitlePlug: '来自',
        errorMessageFormat: '不支持的视频格式',
        errorMessageSize: '文件大小超出限制',
        you: '您',
        subject: '请求主题',
        description: '描述',
        descriptionEmptyWarning: '请填写问题描述',
        conversationEnded: '对话已结束',
        system: '系统消息',
        messageDelivered: '系统已接收消息',
    },
    receipt: {
        generation: '正在生成收据',
        wait: '这可能需要一些时间，请耐心等待。'
    },
    blocked: {
        title: '(简体): 访问受限',
        ip: '来自您所在地区的用户无法访问本网站。对于带来的不便，我们深表歉意，并感谢您的理解。'
    },
}

export default {
    translation,
}
